import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { HistoricoLimiteFundoCadastro } from "src/app/model/limite-agente-financeiro.model";
import { LimitePagamentoEcgTerceiro } from "src/app/model/limite-pagamento-ecg-terceiro";
import { ResultadoPaginado } from "src/app/model/resultado";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

export interface EntradaLimitePagamentoEcgTerceiro {
  id?: number;
  ideTipoPagamentoEcgTerceiro: number;
  dataReferencia: Date;
  valorLimiteTotal: number;
  comentarios: string;
}

@Injectable({
  providedIn: "root",
})
export class LimitePagamentoEcgTerceiroService extends FgiBackEndService<LimitePagamentoEcgTerceiro> {
  getNewEntity(): LimitePagamentoEcgTerceiro {
    return new LimitePagamentoEcgTerceiro();
  }
  protected getResourceURL(): string {
    return "front/limite-pagamento-ecg-terceiros";
  }

  buscarPorIdeTipo(
    ideTipoPagamentoEcgTerceiro: number
  ): Promise<LimitePagamentoEcgTerceiro> {
    return this.http
      .get<LimitePagamentoEcgTerceiro>(
        `${this.BASE_URL}/tipo/${ideTipoPagamentoEcgTerceiro}/ultimo`
      )
      .toPromise();
  }

  salvar(
    entrada: EntradaLimitePagamentoEcgTerceiro
  ): Promise<LimitePagamentoEcgTerceiro> {
    return this.http
      .post<LimitePagamentoEcgTerceiro>(this.BASE_URL, entrada)
      .pipe(catchError((e) => this.handleError(e)))
      .toPromise();
  }

  buscarLimitesPagamentoEcgTerceiros(): Observable<LimitePagamentoEcgTerceiro[]> {
    const options = blockUi();
    return this.http.get<LimitePagamentoEcgTerceiro[]>(this.BASE_URL, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<LimitePagamentoEcgTerceiro[]>;
  }

  buscarHistoricoPorIdeTipo(
    ideTipoPagamentoEcgTerceiro: number, params: any
  ): Promise<ResultadoPaginado<HistoricoLimiteFundoCadastro>> {
    const options = blockUi();
    return this.http
      .get<ResultadoPaginado<HistoricoLimiteFundoCadastro>>(
        `${this.BASE_URL}/tipo/${ideTipoPagamentoEcgTerceiro}/historico`, { ...options, params }
      ).toPromise();
  }

  buscarLimitesPagamentoEcgTerceirosPorTipo(ideTipo: number): Observable<LimitePagamentoEcgTerceiro[]> {
    const options = blockUi();
    return this.http.get<LimitePagamentoEcgTerceiro[]>(`${this.BASE_URL}/todos-por-tipo/${ideTipo}`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<LimitePagamentoEcgTerceiro[]>;
  }


}
